export default "/images/img_2.webp?e2c77c9404b1de4eb50ce3803d76d453";